import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { validate } from "commons/src/helpers/PasswordValidation";

import { AuthTextInput } from "./AuthTextInput";
import { ShowPasswordButton } from "./ShowPasswordButton";
import { PasswordValidationErrorsList } from "./PasswordValidationErrorsList";

export function PasswordInput({ username, setPassword, autocompleteDisabled }) {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [arePasswordsVisible, setArePasswordsVisible] = useState(false);

    useEffect(() => {
        const passedValidation = validate(username, newPassword, confirmPassword).length === 0;
        setPassword(passedValidation ? newPassword : "");
    }, [username, newPassword, confirmPassword, setPassword]);

    const validationFailures = validate(username, newPassword, confirmPassword);

    return (
        <Container>
            <AuthTextInput
                data-testid="password-input-new"
                type={arePasswordsVisible ? "text" : "password"}
                label="New password"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                autoComplete={autocompleteDisabled ? "new-password" : "on"}
                InputProps={{
                    endAdornment: (
                        <ShowPasswordButton
                            data-testid="show-password-button"
                            handleClickShowPassword={() => setArePasswordsVisible(v => !v)}
                            isPasswordVisible={arePasswordsVisible}
                        />
                    )
                }}
            />

            <AuthTextInput
                data-testid="password-input-confirm"
                type={arePasswordsVisible ? "text" : "password"}
                label="Confirm new password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                autoComplete={autocompleteDisabled ? "new-password" : "on"}
                InputProps={{
                    endAdornment: (
                        <ShowPasswordButton
                            handleClickShowPassword={() => setArePasswordsVisible(v => !v)}
                            isPasswordVisible={arePasswordsVisible}
                        />
                    )
                }}
            />

            <PasswordValidationErrorsList errors={validationFailures} />
        </Container>
    );
}

const Container = styled.div`
    margin-bottom: 2rem;
`;

PasswordInput.propTypes = {
    username: PropTypes.string,
    setPassword: PropTypes.func,
    autocompleteDisabled: PropTypes.bool
};
